<script setup lang="ts">
const props = defineProps<{
  rows: any[]
}>()
</script>

<template>
  <div
    class="xs:mt-12 lg:mt-12 xs:mb-12 lg:mb-0 not-prose overflow-x-auto shadow ring-1 ring-black ring-opacity-5 rounded-lg"
  >
    <div class="inline-block min-w-full align-middle">
      <table class="min-w-full divide-y divide-[#E4E7EC]">
        <tbody class="divide-y divide-[#E4E7EC] bg-white">
          <tr :key="_key" v-for="{ _key, cells } in rows">
            <td
              class="max-w-[1px] py-4 px-3 text-sm text-gray-500 break-words"
              :key="cellText"
              v-for="cellText in cells"
              v-text="cellText"
            />
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
